// import './ios-alert.less'
import './ios-alert.css'

export default ({
  msg = '',
  cancelText = '取消',
  confirmText = '确定',
  handleCancel = null,
  handleConfirm = null
} = {}) => {
  /*const template = `
    <div id="ios-alert" class="ios-alert">
      <div class="ios-alert-cover"></div>
      <div class="ios-alert-pop">
        <div class="ios-alert-pop-content">${msg}</div>
        <div class="ios-alert-pop-footer">
            <a id="ios-alert-cancel" href="javascript:;">${cancelText}</a>
            <a id="ios-alert-confirm" href="javascript:;">${confirmText}</a>
        </div>
      </div>
    </div>
  `*/
  const template = `
    <div id="ios-alert" class="ios-alert">
      <div class="ios-alert-cover"></div>
      <div class="ios-alert-pop">
        <div class="ios-alert-pop-content">${msg}</div>
        <div class="ios-alert-pop-footer">
            <a id="ios-alert-cancel" href="javascript:;">${cancelText}</a>
            <a id="ios-alert-confirm" href="javascript:;">${confirmText}</a>
        </div>
      </div>
    </div>
  `

  const alertDiv = document.createElement('div')
  alertDiv.innerHTML = template
  document.body.appendChild(alertDiv)

  document.getElementById('ios-alert-cancel').addEventListener('click', () => {
    alertDiv.parentNode.removeChild(alertDiv)
    handleCancel && handleCancel()
  })

  document.getElementById('ios-alert-confirm').addEventListener('click', () => {
    alertDiv.parentNode.removeChild(alertDiv)
    handleConfirm && handleConfirm()
  })
}




// WEBPACK FOOTER //
// ./node_modules/@common/dialog/src/index.js